import { Auth } from "aws-amplify";
import { clearRefresh } from "lib/bridge";

interface SignOutOptions {
  redirectTo?: string;
  onSignedOut?: () => void;
}

export async function signOutEverywhere(
  options?: SignOutOptions,
): Promise<void> {
  try {
    await Auth.signOut({ global: true } as any);
  } catch (error) {
    console.warn("Failed to sign out of Cognito globally", error);
  }

  try {
    await clearRefresh();
  } catch (error) {
    console.warn("Failed to clear bridge refresh token", error);
  }

  options?.onSignedOut?.();

  if (options?.redirectTo) {
    window.location.assign(options.redirectTo);
  }
}
